import {
  LineChart as ReLineChart,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Line,
} from "recharts";

import { Tooltip } from "./Tooltip";
import { nFormatter } from "../../services";
import { COLORS } from "../../theme/colors";
import { TooltipContent } from "./TooltipContent";

export const LineChart = ({
  chartData,
  chartLines,
  height,
  dot,
  xAxisPadding,
  margin,
  hideSum,
  toolTipLabel,
  unit,
  ticks,
  yTickFormatter,
}) => {
  return (
    <ResponsiveContainer width="100%" height={height || 200}>
      <ReLineChart data={chartData} margin={margin}>
        <CartesianGrid vertical={false} strokeDasharray="5 2" />
        <XAxis tickLine={false} dataKey="x" padding={xAxisPadding} interval={0} ticks={ticks} />
        <YAxis axisLine={false} tickLine={false} width={35} tickFormatter={yTickFormatter} />
        <Tooltip
          chartData={chartData}
          content={<TooltipContent defaultLabel={toolTipLabel} hideSum={hideSum} />}
        />
        {chartLines.map((line, i) => (
          <Line
            connectNulls
            key={i}
            type="monotone"
            strokeWidth={2}
            dataKey={line.dataKey}
            stroke={line.stroke}
            dot={dot}
            unit={unit}
            name={line.name}
          />
        ))}
      </ReLineChart>
    </ResponsiveContainer>
  );
};

LineChart.defaultProps = {
  dot: true,
  chartLines: [{ dataKey: "consumption", stroke: COLORS.purple }],
  xAxisPadding: {},
  margin: {
    top: 5,
    bottom: 5,
    right: 5,
    left: 5,
  },
  hideSum: false,
  toolTipLabel: null,
  unit: null,
  ticks: [],
  yTickFormatter: nFormatter,
};
